import classnames from 'classnames';
import React from 'react';
import { connect } from 'react-redux';
import '../../../assets/styles/components/apply-self-defined-user-id.scss';
import Tips from '../../Tips/Tips';
import { tipsType } from '@/constants/tips-type';
import { Validators } from '../../../helpers/functions';
import {applySelfFDefinedUserIdAction} from '@/actions/auth/auth.action'
import { PARAMS } from '@/constants/params';
import { SERVICES_RESP } from '@/configurations';
// import { removeChild } from '@/actions/app/dialog.action'
class ApplySelfDefinedUserIDForm extends React.Component {
  constructor(props) {
    super(props);
    props.innerRef(this);
    this.state = {
      isSuccess: false,
      resText: '',
      isShowTips: false,
    }
  }

  sendSelfDefinedUserId = () => {
    const params = {
      [PARAMS.CLIENT_ID] : this.props.currentTradingAccount.clientID,
      [PARAMS.TRADING_ACCOUNT_ID] : this.props.currentTradingAccount.clientID,
      [PARAMS.USER_NAME] : this.selfDefinedUserIdRef.value,
    };
    this.validators()
    setTimeout(()=>{
      if(this.state.isSuccess){
        this.props.applySelfFDefinedUserIdAction(params,res => {
          if(res.result.errorCode === SERVICES_RESP.SUCCESS_CODE && res.result.isSuccess === 'Y'){
            this.props.callback()
          }else{
            this.setState({
              isSuccess: false,
              resText:res.result.errorMessage,
              isShowTips:true,
              validatorsCode: 0
            })
          }
        });
      }
    }, 0)

  }

  validators = () => {
    const {language} = this.props;
    if(this.selfDefinedUserIdRef.value === ''){
        this.setState({
          isSuccess: false,
          resText: language.apply_self_defined_user_id_ph,
          isShowTips: true,
          validatorsCode: 1
        })
    } else if(this.confirmSelfDefinedUserIdRef.value === ''){
        this.setState({
          isSuccess: false,
          resText: language.apply_confirm_self_defined_user_id_ph,
          isShowTips: true,
          validatorsCode: 2
        })
    } else if(this.selfDefinedUserIdRef.value !== this.confirmSelfDefinedUserIdRef.value) {
        this.setState({
          isSuccess: false,
          resText: language.apply_self_defined_user_id_two_inputs,
          isShowTips: true,
          validatorsCode: 3
        })
    } else if(!Validators.selfDefinedUserId(this.selfDefinedUserIdRef.value)){
        this.setState({
          isSuccess: false,
          resText: language.apply_self_defined_user_id_warning,
          isShowTips: true,
          validatorsCode: 4
        })
    } else{
      this.setState({
        isSuccess: true,
        resText: '',
        isShowTips: false,
        validatorsCode: 0
      })
    }
  }

  clearInfo = () => {
    this.selfDefinedUserIdRef.value = ''
    this.confirmSelfDefinedUserIdRef.value = ''
    this.setState({
      isSuccess: false,
      resText: '',
      isShowTips: false,
      validatorsCode: 0
    })
  }



  render() {
    const { language, currentTradingAccount,user} = this.props;
    const { isSuccess,resText,isShowTips,validatorsCode} = this.state;
    return (
      <React.Fragment>
        {
          isShowTips && <Tips type={isSuccess ? tipsType.success : tipsType.error}>
          {resText}
        </Tips>
        }
          <section className={'apply-self-deined-info font-bold'}>
            <div className={'show-item'}>
              <div className={'item-left'}>{language.self_defined_user_id_account_no}</div>
              <div>{currentTradingAccount.clientID ? currentTradingAccount.clientID : '-'}</div>
            </div>
            <div className={'show-item'}>
              <div className={'item-left'}>{language.self_defined_user_id_account_name}</div>
              <div>{user.external.fullname ? user.external.fullname  : '-'}</div>
            </div>
          </section>
          <section className={'apply-self-deined-form-table'}>
            <div className={'form-row'}>
              <div className={'form-label'}>
                {language.apply_self_defined_user_id}
              </div>
              <div className={'form-input'}>
                <input className={[1,3,4].includes(validatorsCode) ? 'warning-border' : ''} ref={(e)=>{this.selfDefinedUserIdRef = e}} type="text" placeholder={language.apply_self_defined_user_id_ph} />
                <Tips type={tipsType.error} showIcon={false} isNoBgColor style={{ lineHeight: '1.5em', padding: 0, margin: '10px 0 0', textAlign: 'justify', fontWeight: '400' }}>
                  {language.apply_self_defined_user_id_warning}
                </Tips>
              </div>
            </div>
            <div className={'form-row'}>
              <div className={'form-label'}>
                {language.apply_confirm_self_defined_user_id}
              </div>
              <div className={'form-input'}>
                <input className={[2,3,4].includes(validatorsCode) ? 'warning-border' : ''} ref={(e) => {this.confirmSelfDefinedUserIdRef = e}} type="text" placeholder={language.apply_confirm_self_defined_user_id_ph} />
              </div>
            </div>
          </section>
          <section className="action_panel">
            <button className="clear" onClick={() => this.clearInfo()}>{language.common_clear}</button>
            <button className="submit" onClick={() => this.sendSelfDefinedUserId()}>{language.common_submit}</button>
          </section>
      </React.Fragment>
    )
  }

  componentDidUpdate(prevProps) {
  }

  componentDidMount() {

  }
}

ApplySelfDefinedUserIDForm.defaultProps = {
  innerRef: () => { },
  callback: () => { },
  infoTips: false
}

export default connect(
  state => ({
    language: state.app.language,
    currentTradingAccount: state.trade.currentTradingAccount,
    user: state.auth.user,
    username: state.auth.username
  }),
  dispatch => ({
    applySelfFDefinedUserIdAction: (p, res) => dispatch(applySelfFDefinedUserIdAction(p, res))
  })
  // dispatch => ({
  //   loginAction: (p, c) => dispatch(loginAction(p, c))
  // })
)(ApplySelfDefinedUserIDForm);
